export default __webpack_public_path__ + "static/media/expense_tracker.fd05bb35.png";